import { ChangeDetectorRef, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { lastValueFrom } from 'rxjs';
import { setViewRootFolder } from 'FoldersApp/state/view-root-folder/view-root-folder.action';
import { UNKNOWN_ERROR_MESSAGE } from 'RTQApp/features/rtq-shared/constants/constants';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { RTQAssessmentsFolderableCollectionService } from 'RTQApp/services/rtq-assessments-folderable-collection-ajax.service';
import { RiskToleranceQuestionnaireService } from 'RTQApp/services/rtq-service';
import * as i0 from "@angular/core";
import * as i1 from "RTQApp/services/rtq-assessments-folderable-collection-ajax.service";
import * as i2 from "RTQApp/services/rtq-service";
import * as i3 from "@ngrx/store";
import * as i4 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i5 from "NewAngular/services/core/urls.service";
const _c0 = ["basicInfoForm"];
export var StartRTQModalStep;
(function (StartRTQModalStep) {
    StartRTQModalStep[StartRTQModalStep["ACTIVE_ASSESSMENT_FOUND"] = 0] = "ACTIVE_ASSESSMENT_FOUND";
    StartRTQModalStep[StartRTQModalStep["SELECT_QUESTIONNAIRE"] = 1] = "SELECT_QUESTIONNAIRE";
    StartRTQModalStep[StartRTQModalStep["BASIC_INFO"] = 2] = "BASIC_INFO";
})(StartRTQModalStep || (StartRTQModalStep = {}));
export class StartRTQAssessmentModalBaseDirective {
    get isOnActiveAssessmentFoundStep() {
        return this.currentStep === StartRTQModalStep.ACTIVE_ASSESSMENT_FOUND;
    }
    get isOnSelectQuestionnaireStep() {
        return this.currentStep === StartRTQModalStep.SELECT_QUESTIONNAIRE;
    }
    get isOnBasicInfoStep() {
        return this.currentStep === StartRTQModalStep.BASIC_INFO;
    }
    constructor(cd, folderableCollectionService, rtqService, store, toastMessagesService, urlsService) {
        this.cd = cd;
        this.folderableCollectionService = folderableCollectionService;
        this.rtqService = rtqService;
        this.store = store;
        this.toastMessagesService = toastMessagesService;
        this.urlsService = urlsService;
        this.createdAssessment = new EventEmitter();
        this.modalOpen = false;
        this.modalHeader = 'Select Questionnaire';
        this.submitButtonText = 'Next';
        this.selectedQuestionnaireId = null;
        this.isSubmitting = false;
        this.model = {
            clientName: '',
            assessmentName: '',
        };
        this.asyncCreated = false;
        this.registrationId = null;
        this.currentStep = StartRTQModalStep.SELECT_QUESTIONNAIRE;
        this.questionnaires = [];
    }
    closeModal() {
        this.modalOpen = false;
        this.cd.detectChanges();
    }
    cancel() {
        if (this.isOnBasicInfoStep) {
            this.asyncCreated = false;
            this.goToStep(StartRTQModalStep.SELECT_QUESTIONNAIRE);
            return;
        }
        this.closeModal();
    }
    async submit(isAsync, clientEmail) {
        if (this.isOnSelectQuestionnaireStep) {
            this.goToStep(StartRTQModalStep.BASIC_INFO);
            return;
        }
        if (!this.isOnBasicInfoStep || !this.selectedQuestionnaireId) {
            return;
        }
        if (this.basicInfoForm?.invalid) {
            this.basicInfoForm.form.markAllAsTouched();
            return;
        }
        if (this.isSubmitting) {
            return;
        }
        this.isSubmitting = true;
        try {
            const response = await lastValueFrom(this.rtqService.createNewAssessment(this.model.clientName.trim(), this.model.assessmentName.trim(), this.selectedQuestionnaireId, isAsync, this.folderableCollectionService.viewRootFolder?.id, this.registrationId, clientEmail));
            this.store.dispatch(setViewRootFolder({ id: response.parent_folder_id }));
            if (isAsync) {
                this.asyncCreated = true;
                this.cd.detectChanges();
            }
            else {
                this.closeModal();
            }
            this.createdAssessment.emit(response.assessment);
        }
        catch (error) {
            this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
        }
        finally {
            this.isSubmitting = false;
        }
    }
    selectQuestionnaire(questionnaireId) {
        this.selectedQuestionnaireId = questionnaireId;
    }
    isQuestionnaireSelected(questionnaireId) {
        return this.selectedQuestionnaireId === questionnaireId;
    }
    isSubmitDisabled() {
        if (this.isSubmitting || this.asyncCreated) {
            return true;
        }
        if (this.isOnActiveAssessmentFoundStep) {
            return false;
        }
        if (this.isOnSelectQuestionnaireStep) {
            return this.selectedQuestionnaireId === null;
        }
        return false;
    }
    async fetchQuestionnaires() {
        try {
            this.questionnaires = await lastValueFrom(this.rtqService.getRiskToleranceQuestionnairesList());
        }
        catch (error) {
            this.toastMessagesService.addMessage(error?.error?.error || UNKNOWN_ERROR_MESSAGE, ToastMessageType.ERROR);
        }
        this.cd.detectChanges();
    }
    goToStep(step) {
        this.currentStep = step;
        if (step === StartRTQModalStep.ACTIVE_ASSESSMENT_FOUND) {
            this.modalHeader = 'Questionnaire Options';
            this.submitButtonText = 'Next';
            return;
        }
        if (step === StartRTQModalStep.SELECT_QUESTIONNAIRE) {
            this.modalHeader = 'Select Questionnaire';
            this.submitButtonText = 'Next';
            return;
        }
        this.modalHeader = 'Basic Info';
        this.submitButtonText = 'Start';
    }
    resetBaseState() {
        this.currentStep = StartRTQModalStep.SELECT_QUESTIONNAIRE;
        this.modalHeader = 'Select Questionnaire';
        this.submitButtonText = 'Next';
        this.isSubmitting = false;
        this.selectedQuestionnaireId = null;
        this.registrationId = null;
        this.asyncCreated = false;
        this.model = {
            clientName: '',
            assessmentName: '',
        };
    }
}
StartRTQAssessmentModalBaseDirective.ɵfac = function StartRTQAssessmentModalBaseDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StartRTQAssessmentModalBaseDirective)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.RTQAssessmentsFolderableCollectionService), i0.ɵɵdirectiveInject(i2.RiskToleranceQuestionnaireService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.PageToastMessagesService), i0.ɵɵdirectiveInject(i5.UrlsService)); };
StartRTQAssessmentModalBaseDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: StartRTQAssessmentModalBaseDirective, viewQuery: function StartRTQAssessmentModalBaseDirective_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.basicInfoForm = _t.first);
    } }, outputs: { createdAssessment: "createdAssessment" } });
